import { Component } from '@theme/component';

/**
 * A custom element that manages a reservation form.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} backCheckbox – The back checkbox element.
 * @property {HTMLElement} chosenStoreContainer – The chosen store container element.
 *
 * @extends Component<Refs>
 */
export class ReservationForm extends Component {
  requiredRefs = ['backCheckbox', 'payloadJson'];

  connectedCallback() {
    super.connectedCallback();

    const chosenLocationId = localStorage.getItem('chosenLocationId');
    const dialog = this.closest('dialog');

    dialog?.addEventListener('close', () => {
      localStorage.removeItem('chosenLocationId');
    });

    if (window.location.search.includes('shop_sign_in=true') && chosenLocationId) {
      const targetButton = dialog?.querySelector(`[data-location-id="${chosenLocationId}"]`);
      // Open through the wrapper so the page scroll lock and scroll restore come from one place.
      this.closest('dialog-component')?.showDialog();
      targetButton?.dispatchEvent(new Event('click'));
      window.history.replaceState({}, '', window.location.pathname);
    }

    localStorage.removeItem('chosenLocationId');
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  chooseLocation({ target }) {
    const { backCheckbox } = this.refs;
    const chosenStoreContainer = this.querySelector('.reservation-modal__chosen-store-container');

    this.chosenLocationID = target.dataset.locationId;
    chosenStoreContainer.innerHTML = target.closest('.reservation-modal__location-container').outerHTML;
    backCheckbox.checked = true;
  }

  saveLocation({ target }) {
    const { locationId } = target.dataset;
    localStorage.setItem('chosenLocationId', locationId);
  }

  async submitReservation() {
    const { payloadJson } = this.refs;
    const payload = JSON.parse(payloadJson?.textContent || null);
    let response = null;

    this.classList.add('reservation-modal--loading');

    if (payload) {
      payload.locationId = `gid://shopify/Location/${this.chosenLocationID}`;
      response = await fetch('/apps/kamera/api/stores/reserve', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
    }

    this.classList.remove('reservation-modal--loading');

    if (response?.status === 200) {
      this.classList.remove('reservation-modal--error');
      this.classList.add('reservation-modal--success');
    } else {
      this.classList.remove('reservation-modal--success');
      this.classList.add('reservation-modal--error');
    }
  }
}

if (!customElements.get('reservation-form')) customElements.define('reservation-form', ReservationForm);
